<template>
  <div class="case-edit-container">
    <!-- 顶部导航栏 -->
    <div class="top-bar">
      <span class="top-bar-title">案件编辑</span>
    </div>

    <!-- 新增/编辑案件表单 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ pageTitle }}</span>
        <!-- 新增/编辑模式下的提示，便于用户区分当前操作类型 -->
        <span v-if="!isEditMode" style="color:#ff9900;font-size:14px;margin-left:20px;">
          当前为新增案件，仅可填写案件基本信息，保存后可进行详细管理。
        </span>
        <span v-else style="color:#67c23a;font-size:14px;margin-left:20px;">
          当前为编辑案件，可管理当事人、材料、庭审等信息。
        </span>
      </div>
      <el-form :model="form" :rules="rules" label-width="100px" ref="formRef">
        <el-row :gutter="24">
          <el-col :span="8">
            <!-- 案件名称，必填校验 -->
            <el-form-item label="案件名称" prop="caseName" required><el-input v-model="form.caseName" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 案号，必填校验 -->
            <el-form-item label="案号" prop="caseNumber" required><el-input v-model="form.caseNumber" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 受理日期，必填校验 -->
            <el-form-item label="受理日期" prop="acceptDate" required><el-date-picker v-model="form.acceptDate" type="date" style="width: 100%;"/></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <!-- 案由，必填校验 -->
            <el-form-item label="案由" prop="caseReason" required><el-input v-model="form.caseReason" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 选择仲裁员，必填校验 -->
            <el-form-item label="选择仲裁员" prop="arbitratorUserIds" required>
              <el-select v-model="form.arbitratorUserIds" multiple placeholder="请选择" style="width: 100%;">
                <el-option v-for="u in arbitratorOptions" :key="u.userId" :value="u.userId" :label="u.userName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 主仲裁员，必填校验 -->
            <el-form-item label="主仲裁员" prop="mainArbitratorUserId" required>
              <el-select v-model="form.mainArbitratorUserId" placeholder="请指定" style="width: 100%;">
                <el-option v-for="u in selectedArbitrators" :key="u.userId" :value="u.userId" :label="u.userName" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <!-- 书记员，必填校验 -->
            <el-form-item label="书记员" prop="clerkUserId" required>
              <el-select v-model="form.clerkUserId" placeholder="请选择" style="width: 100%;">
                <el-option v-for="u in clerkOptions" :key="u.userId" :value="u.userId" :label="u.userName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 状态，必填校验 -->
            <el-form-item label="状态" prop="caseStatus" required>
              <el-select v-model="form.caseStatus" style="width: 100%;"><el-option :value="1" label="办理中" /><el-option :value="2" label="办结" /></el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 保存按钮区域，右下角浮动 -->
        <div class="save-btn-wrapper">
          <el-button type="primary" @click="submitForm">保存</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 当事人信息模块 -->
    <el-card v-if="isEditMode" class="box-card">
      <div slot="header" class="clearfix">
        <span>当事人</span>
        <el-button @click="handleAddParty" style="float: right; padding: 3px 0" type="text">新增当事人</el-button>
      </div>
      <el-table :data="partyList" style="width: 100%">
        <el-table-column prop="partyIdentity" label="当事人地位" :formatter="formatPartyIdentity"></el-table-column>
        <el-table-column prop="partyType" label="类型" :formatter="formatPartyType"></el-table-column>
        <el-table-column prop="partyName" label="名称"></el-table-column>
        <el-table-column prop="mobilePhone" label="手机号码"></el-table-column>
        <el-table-column prop="identityNumber" label="身份证号"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleEditParty(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDeleteParty(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 代理人信息模块（新增部分） -->
    <el-card v-if="isEditMode" class="box-card">
      <div slot="header" class="clearfix">
        <span>代理人</span>
        <el-button @click="handleAddAgent" style="float: right; padding: 3px 0" type="text">新增代理人</el-button>
      </div>
      <el-table :data="agentList" style="width: 100%">
        <el-table-column prop="agentName" label="代理人名称"></el-table-column>
        <el-table-column prop="partyId" label="被代理人" :formatter="formatPartyName"></el-table-column>
        <el-table-column prop="mobilePhone" label="联系电话"></el-table-column>
        <el-table-column prop="identityNumber" label="身份证号"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleEditAgent(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDeleteAgent(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 案件材料模块 -->
    <el-card v-if="isEditMode" class="box-card">
      <div slot="header" class="clearfix">
        <span>案件材料</span>
        <!-- 上传材料按钮，点击弹窗 -->
        <el-button type="primary" @click="openUploadDialog" style="float: right; margin-left: 10px;">上传材料</el-button>
      </div>
      <el-table :data="materialList" style="width: 100%">
        <el-table-column prop="materialName" label="材料名称"></el-table-column>
        <!-- 材料分类显示为中文 -->
        <el-table-column prop="materialCategory" label="材料分类" :formatter="formatMaterialCategory"></el-table-column>
        <!-- 提交当事人列，只在证据分类时显示 -->
        <el-table-column label="提交当事人" :formatter="formatSubmitter"></el-table-column>
        <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handlePreviewMaterial(scope.row)" type="text" size="small" class="action-btn">预览</el-button>
            <el-button @click="handleDownloadMaterial(scope.row)" type="text" size="small" class="action-btn">下载</el-button>
            <el-button @click="handleDeleteMaterial(scope.row)" type="text" size="small" class="action-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 商务风格上传材料弹窗 -->
    <el-dialog
      :visible.sync="uploadDialogVisible"
      title="上传附件材料"
      width="520px"  
      :close-on-click-modal="false"
      custom-class="upload-material-dialog"
    >
      <el-form :model="uploadForm" label-width="100px" class="upload-form">
        <el-form-item label="材料名称" required>
          <el-input v-model="uploadForm.materialName" placeholder="请输入材料名称" maxlength="50" />
        </el-form-item>
        <el-form-item label="材料分类" required>
          <el-select v-model="uploadForm.materialCategory" placeholder="请选择分类" @change="onMaterialCategoryChange">
            <el-option v-for="item in materialCategoryOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <!-- 当事人选择字段，只在证据分类时显示 -->
        <el-form-item label="提交当事人" required v-if="uploadForm.materialCategory === 4">
          <el-select v-model="uploadForm.partyId" placeholder="请选择提交证据的当事人" style="width: 100%;">
            <el-option 
              v-for="party in partyList" 
              :key="party.partyId" 
              :label="`${party.partyName} (${party.partyIdentity === 1 ? '申请人' : '被申请人'})`" 
              :value="party.partyId" 
            />
          </el-select>
        </el-form-item>

        <el-form-item label="选择文件" required>
          <el-upload
            :action="'#'"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :limit="1"
            :file-list="selectedFile ? [{name: selectedFile.name, url: ''}] : []"
            accept=".doc,.docx,.pdf,.jpg,.png,.txt,.xls,.xlsx"
            class="upload-btn-block"
          >
            <el-button type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              <i class="el-icon-info"></i>
              只能上传一个文件，支持格式：DOC、DOCX、PDF、JPG、PNG、TXT、XLS、XLSX
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleManualUpload">上传</el-button>
      </div>
    </el-dialog>

    <!-- 庭审列表模块 -->
    <el-card v-if="isEditMode" class="box-card">
      <div slot="header" class="clearfix">
        <span>庭审列表</span>
        <el-button @click="handleAddHearing" style="float: right; padding: 3px 0" type="text">新增开庭</el-button>
      </div>
      <el-table :data="hearingList" style="width: 100%">
        <el-table-column prop="hearingTime" label="庭审时间"></el-table-column>
        <el-table-column prop="hearingLocation" label="庭审地点"></el-table-column>
        <el-table-column label="庭审类型" :formatter="formatHearingType"></el-table-column>
        <el-table-column label="开庭公告送达状态">
          <template slot-scope="scope">
            {{ calculateSmsDeliveryStatus(scope.row.hearingId) }}
          </template>
        </el-table-column>
        <el-table-column prop="hearingStatus" label="庭审状态" :formatter="formatHearingStatus"></el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <!-- 未开始状态：显示"编辑"和"发送通知"按钮 -->
            <template v-if="scope.row.hearingStatus === HEARING_STATUS.NOT_STARTED">
              <el-button type="text" size="small" class="action-btn" @click="handleEditHearing(scope.row)">编辑</el-button>
              <el-button type="text" size="small" class="action-btn" @click="handleNotifyHearing(scope.row)">发送通知</el-button>
            </template>
            <!-- 预备开庭状态：显示"预备开庭"和"查看详情"按钮 -->
            <template v-else-if="scope.row.hearingStatus === HEARING_STATUS.PREPARING">
              <el-button type="text" size="small" class="action-btn" @click="handlePrepareHearing(scope.row)">预备开庭</el-button>
              <el-button type="text" size="small" class="action-btn" @click="handleViewHearingDetail(scope.row)">查看详情</el-button>
            </template>
            <!-- 进行中状态：显示"查看详情"按钮 -->
            <template v-else-if="scope.row.hearingStatus === HEARING_STATUS.IN_PROGRESS">
              <el-button type="text" size="small" class="action-btn" @click="handleViewHearingDetail(scope.row)">查看详情</el-button>
            </template>
            <!-- 休庭中状态：显示"查看详情"按钮 -->
            <template v-else-if="scope.row.hearingStatus === HEARING_STATUS.PAUSED">
              <el-button type="text" size="small" class="action-btn" @click="handleViewHearingDetail(scope.row)">查看详情</el-button>
            </template>
            <!-- 已结束状态：显示"查看详情"、"查看笔录"、"查看视频"三个按钮 -->
            <template v-else-if="scope.row.hearingStatus === HEARING_STATUS.ENDED">
              <el-button type="text" size="small" class="action-btn" @click="handleViewHearingDetail(scope.row)">查看详情</el-button>
              <el-button type="text" size="small" class="action-btn" @click="handleViewTranscript(scope.row)">查看笔录</el-button>
              <el-button type="text" size="small" class="action-btn" @click="handleViewVideo(scope.row)">查看视频</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑/新增当事人弹窗 -->
    <el-dialog :title="partyForm.partyId ? '编辑当事人' : '新增当事人'" :visible.sync="partyDialogVisible" :close-on-click-modal="false">
      <el-form :model="partyForm" :rules="partyRules" ref="partyFormRef" label-width="100px">
        <!-- 当事人地位 -->
        <el-form-item label="当事人地位" prop="partyIdentity">
          <el-select v-model="partyForm.partyIdentity" placeholder="请选择">
            <el-option :value="1" label="申请人" />
            <el-option :value="2" label="被申请人" />
          </el-select>
        </el-form-item>
        <!-- 类型 -->
        <el-form-item label="类型" prop="partyType">
          <el-select v-model="partyForm.partyType" placeholder="请选择">
            <el-option :value="1" label="自然人" />
            <el-option :value="2" label="法人" />
          </el-select>
        </el-form-item>
        <!-- 名称 -->
        <el-form-item label="名称" prop="partyName">
          <el-input v-model="partyForm.partyName" placeholder="请输入当事人名称" />
        </el-form-item>
        <!-- 手机号码 -->
        <el-form-item label="手机号码" prop="mobilePhone">
          <el-input v-model="partyForm.mobilePhone" placeholder="请输入手机号码" maxlength="11" />
        </el-form-item>
        <!-- 身份证号 -->
        <el-form-item label="身份证号" prop="identityNumber">
           <el-input v-model="partyForm.identityNumber" placeholder="请输入身份证号" maxlength="18" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="partyDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitParty">保存</el-button>
      </div>
    </el-dialog>

    <!-- 笔录弹窗，显示所有仲裁笔录材料 -->
    <el-dialog :visible.sync="recordDialogVisible" title="仲裁笔录列表" :close-on-click-modal="false">
      <el-table :data="recordList">
        <el-table-column prop="materialName" label="文件名" />
        <el-table-column prop="materialType" label="类型" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="downloadMaterial(scope.row.materialId)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 代理人弹窗 -->
    <el-dialog :visible.sync="agentDialogVisible" :title="agentForm.agentId ? '编辑代理人' : '新增代理人'" :close-on-click-modal="false">
      <el-form :model="agentForm" :rules="agentRules" ref="agentFormRef" label-width="100px">
        <el-form-item label="代理人名称" prop="agentName">
          <el-input v-model="agentForm.agentName" placeholder="请输入代理人姓名" />
        </el-form-item>
        <el-form-item label="被代理人" prop="partyId">
          <el-select v-model="agentForm.partyId" placeholder="请选择被代理人" style="width: 100%;">
            <el-option 
              v-for="party in partyList" 
              :key="party.partyId" 
              :value="party.partyId" 
              :label="party.partyName" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobilePhone">
          <el-input v-model="agentForm.mobilePhone" placeholder="请输入手机号码" maxlength="11" />
        </el-form-item>
        <el-form-item label="身份证号" prop="identityNumber">
          <el-input v-model="agentForm.identityNumber" placeholder="请输入身份证号" maxlength="18" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="agentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAgent">保存</el-button>
      </div>
    </el-dialog>

    <!-- 笔录预览弹窗 -->
    <el-dialog :visible.sync="onlyOfficeDialogVisible" width="70vw" top="3vh" :close-on-click-modal="false" :destroy-on-close="true" title="笔录预览" class="material-preview-dialog">
      <OnlyOffice v-if="onlyOfficeDialogVisible"
        :file-url="onlyOfficeFileUrl"
        :file-type="onlyOfficeFileType"
        :title="onlyOfficeFileName"
        mode="view"
        :container-style="'width:100%;height:100%;'"
        :width="'1000px'"
        :height="'85vh'" />
    </el-dialog>
    
    <!-- 图片预览弹窗 -->
    <el-dialog 
      :visible.sync="imagePreviewVisible" 
      :title="currentImageName"
      width="50vw" w
      top="15vh" 
      :close-on-click-modal="false" 
      :destroy-on-close="true"
      class="image-preview-dialog"
      :show-close="true"
    >
      <div class="image-preview-container">
        <img 
          :src="currentImageUrl" 
          :alt="currentImageName"
          class="preview-image"
          @error="handleImageError"
        />
      </div>
    </el-dialog>

    <!-- 新增/编辑开庭弹窗 -->
    <el-dialog 
      :visible.sync="showHearingDialog" 
      :title="hearingDialogMode ? '编辑开庭' : '新增开庭'" 
      width="600px" 
      :close-on-click-modal="false"
    >
      <NewHearing 
        v-if="showHearingDialog"
        :context="'case-edit'"
        :case-id="currentCaseId" 
        :hearing-id="currentHearingId"
        :is-edit="hearingDialogMode"
        @cancel="showHearingDialog = false" 
        @saved="onHearingSaved" />
    </el-dialog>

    <!-- 视频播放弹窗 -->
    <el-dialog
      :visible.sync="videoDialogVisible"
      :title="currentVideoTitle"
      width="800px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="video-dialog"
    >
      <video :src="currentVideoUrl" controls style="width:100%;max-height:60vh;background:#000;" preload="auto"></video>
    </el-dialog>
    
    <!-- 庭审详情模态框 -->
    <HearingDetailModal
      :visible.sync="hearingDetailDialogVisible"
      :hearing-data="currentHearingDetail"
      @close="hearingDetailDialogVisible = false"
    />
  </div>
</template>

<script>
import request from '@/utils/request' // 引入真实API请求工具
import { getAgentsByCaseId, createAgent, updateAgent, deleteAgent } from '@/api/agent'
import OnlyOffice from '@/components/OnlyOffice.vue'
import NewHearing from './NewHearing.vue'
import HearingDetailModal from '@/views/HearingDetailModal.vue' // 引入庭审详情模态框组件
import { HEARING_STATUS } from '@/constants/hearingStatus' // 引入庭审状态常量
import { prepareHearing } from '@/api/hearing' // 引入庭审API接口

export default {
  name: 'CaseEditPage',
  components: { OnlyOffice, NewHearing, HearingDetailModal }, // 注册庭审详情模态框组件
  data() {
    // 自定义身份证号校验函数
    const validateIdentityNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'));
        return;
      }
      
      // 身份证号格式校验
      const idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      if (!idCardReg.test(value)) {
        callback(new Error('身份证号格式不正确'));
        return;
      }
      
      // 身份证号校验码验证
      const validateIdCard = (idCard) => {
        // 加权因子
        const weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 校验码对应值
        const validate = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        
        let sum = 0;
        for (let i = 0; i < 17; i++) {
          sum += parseInt(idCard[i]) * weight[i];
        }
        
        const validateIndex = sum % 11;
        return validate[validateIndex] === idCard[17].toUpperCase();
      };
      
      if (!validateIdCard(value)) {
        callback(new Error('身份证号校验码错误'));
        return;
      }
      
      callback();
    };

    return {
      // 庭审状态常量 - 暴露给模板使用
      HEARING_STATUS: HEARING_STATUS,
      // 顶部表单数据
      form: {
        caseId: null, caseName: '', caseNumber: '', acceptDate: new Date(), caseReason: '', caseStatus: 1,
        arbitratorUserIds: [], mainArbitratorUserId: '', clerkUserId: ''
      },
      // 表单校验规则
      rules: {
        caseName: [{ required: true, message: '请输入案件名称', trigger: 'blur' }],
        caseNumber: [{ required: true, message: '请输入案号', trigger: 'blur' }],
        acceptDate: [{ required: true, message: '请选择受理日期', trigger: 'change' }],
        caseReason: [{ required: true, message: '请输入案由', trigger: 'blur' }],
        arbitratorUserIds: [{ required: true, type: 'array', min: 1, message: '请选择仲裁员', trigger: 'change' }],
        mainArbitratorUserId: [{ required: true, message: '请选择主仲裁员', trigger: 'change' }],
        clerkUserId: [{ required: true, message: '请选择书记员', trigger: 'change' }],
        caseStatus: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      userOptions: [], // 所有用户，仲裁员和书记员都用这个
      tenantId: '', // 当前案件所属单位ID
      // 下方列表数据
      partyList: [],
      materialList: [],
      hearingList: [], // 庭审列表，后端真实数据
      // 编辑/新增当事人弹窗是否显示
      partyDialogVisible: false, // 新增：控制弹窗显示
      // 编辑/新增当事人表单
      partyForm: {
        partyId: '', // 主键
        partyIdentity: 1, // 当事人身份
        partyType: 1, // 当事人类型
        partyName: '', // 名称
        mobilePhone: '', // 手机号
        identityNumber: '', // 身份证号
      },
      // 编辑/新增当事人弹窗标题
      partyDialogTitle: '新增当事人',
      // 编辑/新增当事人弹窗是否显示
      agentDialogVisible: false, // 新增：控制弹窗显示
      // 编辑/新增当事人表单
      agentForm: {
        agentName: '', // 代理人名称
        partyId: '', // 被代理人
        mobilePhone: '', // 联系电话
        identityNumber: '', // 身份证号
      },
      // 编辑/新增代理人弹窗标题
      agentDialogTitle: '新增代理人',
      // 编辑/新增代理人弹窗是否显示
      editingAgentId: null, // 编辑的代理人ID
      // 新增开庭弹窗是否显示
      showHearingDialog: false,
      // 新增开庭弹窗是否显示
      currentCaseId: '',
      // 新增开庭弹窗是否显示
      currentHearingId: '',
      // 庭审弹窗模式：false=新增，true=编辑
      hearingDialogMode: false,
      // 新增开庭弹窗是否显示
      // isEditMode: false, // 已移至computed属性中，避免重复定义
      recordDialogVisible: false, // 控制笔录弹窗显示
      recordList: [], // 仲裁笔录材料列表
      agentList: [], // 代理人列表
      clerkOptions: [], // 书记员下拉数据
      arbitratorOptions: [], // 仲裁员下拉数据
      onlyOfficeDialogVisible: false, // 控制OnlyOffice弹窗显示
      onlyOfficeFileUrl: '', // 预览文件URL
      onlyOfficeFileType: '', // 文件类型
      onlyOfficeFileName: '', // 文件名
      uploadUrl: '/api/material/upload', // 材料上传接口
      uploadExtraData: {}, // 上传额外参数（DTO字符串）
      uploadDialogVisible: false, // 控制上传弹窗显示
      uploadForm: {
        materialName: '', // 材料名称
        materialCategory: null, // 材料分类
        partyId: null // 提交当事人ID
      },
      materialCategoryOptions: [ // 材料分类选项，与数据库一致
        { label: '仲裁申请书', value: 1 },
        { label: '庭审笔录', value: 2 },
        { label: '案件信息（Excel）', value: 3 },
        { label: '证据', value: 4 },
        { label: '其他', value: 5 }
      ],
      uploadData: {}, // 上传参数对象
      selectedFile: null, // 选中的文件
      partyRules: { // 新增当事人表单校验规则
        partyIdentity: [
          { required: true, message: '请选择当事人地位', trigger: 'change' }
        ],
        partyType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        partyName: [
          { required: true, message: '请输入当事人名称', trigger: 'blur' },
          { min: 2, max: 50, message: '当事人名称长度在2到50个字符', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        identityNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateIdentityNumber, trigger: 'blur' }
        ]
      },
      agentRules: { // 新增代理人表单校验规则
        agentName: [
          { required: true, message: '请输入代理人名称', trigger: 'blur' },
          { min: 2, max: 50, message: '代理人名称长度在2到50个字符', trigger: 'blur' }
        ],
        partyId: [
          { required: true, message: '请选择被代理人', trigger: 'change' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        identityNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateIdentityNumber, trigger: 'blur' }
        ]
      },
      videoDialogVisible: false, // 控制视频播放弹窗显示
      currentVideoUrl: '', // 当前要播放的视频URL
      currentVideoTitle: '', // 当前视频弹窗的标题
      hearingDetailDialogVisible: false, // 控制庭审详情弹窗显示
      currentHearingDetail: null, // 当前查看的庭审详情数据
      // 图片预览相关变量
      imagePreviewVisible: false, // 控制图片预览弹窗显示
      currentImageUrl: '', // 当前预览的图片URL
      currentImageName: '' // 当前预览的图片名称
    };
  },
  computed: {
    pageTitle() { return this.form.caseId ? '编辑案件' : '新增案件'; },
    isEditMode() { return !!this.form.caseId; },
    selectedArbitrators() {
      return this.userOptions.filter(u => this.form.arbitratorUserIds.includes(u.userId));
    },
    uploadHeaders() {
      // 自动带上token
      return {
        Authorization: 'Bearer ' + (localStorage.getItem('token') || '')
      }
    }
  },
  watch: {
    'form.arbitratorUserIds'(newVal) {
      if (newVal && !newVal.includes(this.form.mainArbitratorUserId)) {
        this.form.mainArbitratorUserId = '';
      }
    }
  },
  created() {
    this.form.caseId = this.$route.params.caseId;
    if (this.form.caseId) {
      this.fetchPageData();
    }
    this.loadUserList(); // 页面加载时统一加载用户下拉
  },
  methods: {
    // --- 数据获取 ---
    async fetchUserOptions() {
      // 调用后端接口获取本单位所有用户
      const res = await request.get('/api/user/listByTenant', {
        params: { tenantId: this.tenantId }
      });
      this.userOptions = res.data || [];
    },
    async fetchPageData() {
      // 获取案件详情，填充表单
      const caseRes = await request.get(`/api/case/${this.form.caseId}`);
      if (caseRes && caseRes.data) {
        Object.assign(this.form, caseRes.data);
        // 时间字段格式化
        if (this.form.acceptDate && typeof this.form.acceptDate === 'string') {
          this.form.acceptDate = new Date(this.form.acceptDate);
        }
        // 直接用案件详情里的tenantId
        this.tenantId = caseRes.data.tenantId;
        // 拿到tenantId后再查用户
        await this.fetchUserOptions();
      }
      // 其他数据加载
      this.refreshPartyList();
      this.loadAgentList(); // 加载代理人列表
      // 调用后端真实接口获取材料列表
      const materialRes = await request.get(`/api/material/list/${this.form.caseId}`);
      if (materialRes && materialRes.code === 200) {
        this.materialList = materialRes.data;
      }
      
      // 调用新接口获取按当事人分组的证据材料（示例）
      await this.loadEvidenceByParty();
      // 调用后端真实接口获取庭审列表
      const hearingRes = await request.get('/api/hearing/listByCaseId', { params: { caseId: this.form.caseId } });
      if (hearingRes && hearingRes.code === 200) {
        this.hearingList = hearingRes.data || [];
      } else {
        this.hearingList = [];
      }
    },
    
    // 获取当前登录用户的tenantId（新增模式使用）
    async getCurrentUserTenantId() {
      try {
        // 从localStorage或session中获取当前用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo') || '{}');
        if (userInfo.tenantId) {
          this.tenantId = userInfo.tenantId;
          // 获取到tenantId后，立即获取用户列表
          await this.fetchUserOptions();
        } else {
          // 兜底逻辑已删除，不再调用/api/user/current
          this.$message.error('请先登录');
          this.$router.push('/login');
        }
      } catch (error) {
        // 获取用户tenantId失败
        this.$message.error('获取用户信息失败');
      }
    },

    // --- 顶部表单提交 ---
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        
        if (this.form.caseId) {
          // 编辑案件：调用PUT /api/case，参数结构与新增保持一致
          const payload = {
            caseInfo: { ...this.form }, // 案件基本信息
            arbitratorUserIds: this.form.arbitratorUserIds, // 仲裁员用户ID列表
            mainArbitratorUserId: this.form.mainArbitratorUserId // 主仲裁员用户ID
          };
          // 删除冗余字段，避免重复
          delete payload.caseInfo.arbitratorUserIds;
          delete payload.caseInfo.mainArbitratorUserId;
          await request.put('/api/case', payload); // 发送PUT请求
          this.$message.success('更新成功');
        } else {
          // 新增案件：调用POST /api/case/create
          const payload = {
            caseInfo: { ...this.form },
            arbitratorUserIds: this.form.arbitratorUserIds,
            mainArbitratorUserId: this.form.mainArbitratorUserId
          };
          delete payload.caseInfo.arbitratorUserIds;
          delete payload.caseInfo.mainArbitratorUserId;
          await request.post('/api/case/create', payload);
          this.$message.success('新增成功');
        }
        
        this.goBack();
      });
    },
    goBack() { this.$router.go(-1); },

    // --- 格式化方法 ---
    formatPartyIdentity(r) { return { 1: '申请人', 2: '被申请人' }[r.partyIdentity] ||''; },
    formatPartyType(r) { return { 1: '自然人', 2: '法人' }[r.partyType] || ''; },
    formatHearingStatus(r) { 
        // 修复庭审状态映射，与后端常量一致
        const statusMap = {
            1: '未开始',    // NOT_STARTED
            2: '进行中',    // IN_PROGRESS  
            3: '休庭中',    // PAUSED
            4: '已结束',    // ENDED
            5: '预备开庭'   // PREPARING
        };
        return statusMap[r.hearingStatus] || '未知状态';
    },
    // 格式化庭审类型
    formatHearingType(row) {
      const typeMap = {
        1: '调解',    // 调解
        2: '仲裁'     // 仲裁
      };
      
      const result = typeMap[row.hearingType] || '未知类型';
      return result;
    },
    // 格式化被代理人名称
    formatPartyName(row) {
      const party = this.partyList.find(p => p.partyId === row.partyId);
      return party ? party.partyName : '未知';
    },
    getMaterialIcon(name) {
      const ext = name ? name.split('.').pop().toLowerCase() : '';
      if (['doc', 'docx'].includes(ext)) return 'el-icon-document';
      if (['pdf'].includes(ext)) return 'el-icon-tickets';
      if (['jpg', 'png'].includes(ext)) return 'el-icon-picture-outline';
      return 'el-icon-folder';
    },

    // --- 各模块操作方法 (占位) ---
    handleAddParty() {
      // 清空表单，显示弹窗
      this.partyForm = {
        partyId: '',
        partyIdentity: 1,
        partyType: 1,
        partyName: '',
        mobilePhone: '',
        identityNumber: ''
      };
      this.partyDialogVisible = true;
    },
    handleEditParty(row) {
      // 回显数据，显示弹窗
      this.partyForm = { 
        ...row, 
        identityNumber: row.identityNumber || '' 
      };
      this.partyDialogVisible = true;
    },
    async submitParty() {
      this.$refs.partyFormRef.validate(async (valid) => {
        if (!valid) return;

        // 从localStorage获取tenantId
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const tenantId = userInfo.tenantId;
        
        // 判断是新增还是编辑
        if (this.partyForm.partyId) {
          // 编辑，调用PUT接口
          await request.put('/api/party', {
            ...this.partyForm,
            caseId: this.form.caseId, // 传递案件ID
            tenantId: tenantId // 传递租户ID
          });
          this.$message.success('修改当事人成功');
        } else {
          // 新增，调用POST接口
          await request.post('/api/party', {
            ...this.partyForm,
            caseId: this.form.caseId, // 传递案件ID
            tenantId: tenantId // 传递租户ID
          });
          this.$message.success('新增当事人成功');
        }
        this.partyDialogVisible = false; // 关闭弹窗
        this.refreshPartyList(); // 刷新当事人列表
      });
    },
    async refreshPartyList() {
      // 调用后端接口获取当事人列表
      const res = await request.get('/api/party/list', { params: { caseId: this.form.caseId } });
      if (res.data && res.code === 200) {
        this.partyList = res.data;
      }
    },
    
    /**
     * 获取按当事人分组的证据材料（新接口示例）
     */
    async loadEvidenceByParty() {
      try {
        const res = await request.get(`/api/material/evidenceByParty/${this.form.caseId}`);
        if (res && res.code === 200) {
          const evidenceByParty = res.data;
          console.log('按当事人分组的证据材料:', evidenceByParty);
          
          // 遍历每个当事人的证据材料
          for (const [partyId, materials] of Object.entries(evidenceByParty)) {
            // 找到对应的当事人信息
            const party = this.partyList.find(p => p.partyId === partyId);
            const partyName = party ? party.partyName : '未知当事人';
            
            console.log(`当事人 ${partyName} (${partyId}) 的证据材料:`);
            materials.forEach(material => {
              console.log(`  - ${material.materialName} (${material.materialType})`);
            });
          }
          
          // 这里可以根据需要将数据存储到组件的data中，或者进行其他处理
          // this.evidenceByParty = evidenceByParty;
        }
      } catch (error) {
        console.error('获取按当事人分组的证据材料失败:', error);
      }
    },
    async handleDeleteParty(row) {
      this.$confirm('确定要删除该当事人吗？', '提示', { type: 'warning' })
        .then(async () => {
          await request.delete(`/api/party/${row.partyId}`);
          this.$message.success('删除成功');
          // 同时刷新当事人列表和代理人列表
          this.refreshPartyList();
          this.loadAgentList();
        })
        .catch(() => {});
    },
    handleUploadMaterial() { this.$message.info('上传材料'); },
    async handlePreviewMaterial(row) {
      try {
        // 1. 获取材料的下载URL
        const res = await request.get(`/api/material/download/${row.materialId}`)
        if (!res.data) {
          this.$message.error('获取材料预览链接失败')
          return
        }
        
        // 2. 获取文件扩展名
        // 优先使用数据库的materialType，如果没有则从文件名提取
        const fileExtension = row.materialType || row.materialName.split('.').pop().toLowerCase()
        
        // 3. 判断文件类型，选择不同的预览方式
        if (this.isImageFile(fileExtension)) {
          // 图片文件：使用图片预览弹窗
          this.previewImage(row.materialName, res.data)
        } else if (this.isDocumentFile(fileExtension)) {
          // 文档文件：使用 OnlyOffice 预览
          this.previewDocument(row.materialName, res.data, fileExtension)
        } else {
          // 不支持预览的文件类型
          this.$message.warning(`不支持预览 ${fileExtension.toUpperCase()} 格式文件，请下载后查看`)
        }
      } catch (error) {
        console.error('预览材料失败:', error)
        this.$message.error('预览失败，请重试')
      }
    },
    
    // 判断是否为图片文件
    isImageFile(extension) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension.toLowerCase())
    },
    
    // 判断是否为文档文件
    isDocumentFile(extension) {
      const documentExtensions = [
        'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'rtf',
        'odt', 'ods', 'odp', 'docm', 'dot', 'dotx', 'xlsm', 'xlt', 'xltx',
        'pptm', 'pot', 'potx', 'epub', 'fb2', 'fodt', 'htm', 'html', 'mht',
        'mhtml', 'ott', 'pages', 'stw', 'sxw', 'wps', 'wpt', 'xml'
      ]
      return documentExtensions.includes(extension.toLowerCase())
    },
    
    // 预览图片
    previewImage(fileName, imageUrl) {
      this.currentImageUrl = imageUrl
      this.currentImageName = fileName
      this.imagePreviewVisible = true
    },
    
    // 预览文档
    previewDocument(fileName, fileUrl, fileExtension) {
      this.onlyOfficeFileUrl = fileUrl
      // 根据文件扩展名正确设置OnlyOffice支持的文件类型
      const fileTypeMap = {
        'doc': 'doc',
        'docx': 'docx',
        'xls': 'xls',
        'xlsx': 'xlsx',
        'ppt': 'ppt',
        'pptx': 'pptx',
        'pdf': 'pdf',
        'txt': 'txt',
        'rtf': 'rtf',
        'odt': 'odt',
        'ods': 'ods',
        'odp': 'odp'
      }
      this.onlyOfficeFileType = fileTypeMap[fileExtension] || 'docx' // 默认使用docx
      this.onlyOfficeFileName = fileName
      // 预览文件信息已设置
      this.onlyOfficeDialogVisible = true
    },
    
    // 处理图片加载错误
    handleImageError(event) {
      console.error('图片加载失败:', event)
      this.$message.error('图片加载失败，请检查文件是否损坏')
      // 可以显示一个占位图片
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y1ZjVmNSIvPjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZtaWxseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7lm77niYflrprnlKjlm748L3RleHQ+PC9zdmc+'
    },
    
    // 下载材料方法
    async handleDownloadMaterial(r) { 
      try {
        // 使用直接下载接口，而不是获取预签名URL
        const downloadUrl = `/api/material/download/file/${r.materialId}`;
        
        // 创建下载链接并触发下载
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = r.materialName || '材料文件';
        link.target = '_blank';
        link.style.display = 'none';
        
        // 添加token到下载链接
        const token = localStorage.getItem('token');
        if (token) {
          link.href = downloadUrl + '?token=' + token;
        }
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // 不显示提示，静默下载
      } catch (error) {
        this.$message.error('下载失败，请重试');
      }
    },
    async handleDeleteMaterial(r) {
      // 确认删除操作
      this.$confirm(`确定要删除材料 "${r.materialName}" 吗？删除后无法恢复。`, '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 调用后端删除接口
          const res = await request.delete(`/api/material/${r.materialId}`);
          if (res && res.code === 200) {
            this.$message.success('删除成功');
            // 刷新材料列表
            this.fetchPageData();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          console.error('删除材料失败:', error);
          this.$message.error('删除失败，请重试');
        }
      }).catch(() => {
        // 用户取消删除，不做任何操作
      });
    },
    // 材料分类映射方法
    getMaterialTypeName(materialType) {
      // 材料分类映射表
      const materialTypeMap = {
        1: '仲裁申请书', // 仲裁申请书
        2: '庭审笔录', // 庭审笔录
        3: '案件信息（Excel）', // 案件信息（Excel）
        4: '证据', // 证据
        5: '其他', // 其他材料
        6: '裁决书', // 裁决书
        7: '调解书', // 调解书
        8: '决定书', // 决定书
        9: '通知书', // 通知书
        10: '其他法律文书' // 其他法律文书
      };
      return materialTypeMap[materialType] || '未知分类';
    },
    handleAddHearing() {
      // 先关闭所有其他弹窗，确保只有新增开庭弹窗是打开的
      this.partyDialogVisible = false;
      this.agentDialogVisible = false;
      this.recordDialogVisible = false;
      this.onlyOfficeDialogVisible = false;
      this.videoDialogVisible = false;
      this.hearingDetailDialogVisible = false;
      this.imagePreviewVisible = false;
      
      // 设置新增开庭弹窗状态
      this.currentCaseId = this.form.caseId;
      this.hearingDialogMode = false; // 设置为新增模式
      this.currentHearingId = ''; // 清空庭审ID
      this.showHearingDialog = true;
    },
    onHearingSaved() {
      // 先关闭新增开庭弹窗
      this.showHearingDialog = false;
      this.hearingDialogMode = false; // 重置弹窗模式
      this.currentHearingId = '';
      
      // 确保所有其他弹窗都被关闭
      this.partyDialogVisible = false;
      this.agentDialogVisible = false;
      this.recordDialogVisible = false;
      this.onlyOfficeDialogVisible = false;
      this.videoDialogVisible = false;
      this.hearingDetailDialogVisible = false;
      this.imagePreviewVisible = false;
      
      // 延迟刷新庭审列表，确保数据已保存
      this.$nextTick(() => {
        setTimeout(() => {
          // 调用正确的方法刷新庭审列表
          this.fetchPageData && this.fetchPageData(); // 刷新庭审列表
        }, 500); // 延迟500ms确保数据保存完成
      });
    },
    handleEditHearing(r) { 
      // 关闭所有其他弹窗，确保只有编辑弹窗是打开的
      this.partyDialogVisible = false;
      this.agentDialogVisible = false;
      this.recordDialogVisible = false;
      this.onlyOfficeDialogVisible = false;
      this.videoDialogVisible = false;
      this.hearingDetailDialogVisible = false;
      this.imagePreviewVisible = false;
      
      // 设置当前编辑的庭审信息
      this.currentHearingId = r.hearingId;
      this.currentCaseId = r.caseId;
      this.hearingDialogMode = true; // 设置为编辑模式
      
      // 打开编辑弹窗
      this.showHearingDialog = true;
    },
    /**
     * 查看笔录，点击按钮时触发
     * @param {Object} row 当前表格行数据
     */
    async handleViewTranscript(row) {
      // 1. 获取当前行的document_id
      const documentId = row.documentId || row.document_id;
      if (!documentId) {
        this.$message.warning('该庭审未生成笔录文书');
        return;
      }
      try {
        // 2. 先查询文档信息，获取文档名称
        const docInfoRes = await request.get(`/api/document/${documentId}`);
        let fileName = '庭审笔录';
        
        if (docInfoRes && docInfoRes.code === 200 && docInfoRes.data) {
          // 如果有文档信息，使用文档名称
          fileName = docInfoRes.data.documentName || '庭审笔录';
        } else {
          // 如果没有文档信息，使用默认名称
          fileName = `庭审笔录_${row.hearingTime || '未知时间'}`;
        }
        
        // 3. 调用后端接口获取文书下载链接
        const res = await request.get(`/api/document/download/${documentId}`);
        if (res && res.code === 200 && res.data) {
          // 4. 推断文件扩展名
          const fileExtension = fileName.split('.').pop().toLowerCase();
          // 5. 文件类型映射表
          const fileTypeMap = {
            'doc': 'doc',
            'docx': 'docx',
            'xls': 'xls',
            'xlsx': 'xlsx',
            'ppt': 'ppt',
            'pptx': 'pptx',
            'pdf': 'pdf',
            'txt': 'txt',
            'rtf': 'rtf',
            'odt': 'odt',
            'ods': 'ods',
            'odp': 'odp'
          };
          // 6. 没有扩展名时默认docx
          let onlyOfficeFileType = fileTypeMap[fileExtension] || 'docx';
          // 7. 打开OnlyOffice弹窗
          this.onlyOfficeFileUrl = res.data;
          this.onlyOfficeFileType = onlyOfficeFileType;
          this.onlyOfficeFileName = fileName;
          this.onlyOfficeDialogVisible = true;
        } else {
          this.$message.error('未查到笔录文书内容');
        }
      } catch (e) {
        this.$message.error('查询笔录文书失败');
      }
    },
    /**
     * 查看视频，点击按钮时触发
     * @param {Object} row 当前表格行数据
     */
    async handleViewVideo(row) {
      try {
        // 1. 先尝试从行数据获取视频URL
        let videoUrl = row.videoUrl;
        
        // 2. 如果行数据中没有，尝试从后端获取
        if (!videoUrl && row.hearingId) {
          const res = await request.get(`/api/hearing/getHearingById/${row.hearingId}`);
          if (res.code === 200 && res.data && res.data.videoUrl) {
            videoUrl = res.data.videoUrl;
          }
        }
        
        // 3. 如果仍然没有视频URL，提示用户
        if (!videoUrl) {
          this.$message.warning('该庭审未上传视频或视频暂不可用');
          return;
        }
        
        // 4. 打开专门的视频播放弹窗
        this.videoDialogVisible = true;
        this.currentVideoUrl = videoUrl;
        this.currentVideoTitle = `庭审视频 - ${row.hearingTime || '未知时间'}`;
        
      } catch (error) {
        // 获取视频信息失败
        this.$message.error('获取视频信息失败，请重试');
      }
    },
    /**
     * 查看庭审详情，点击按钮时触发
     * @param {Object} row 当前表格行数据
     */
    handleViewHearingDetail(row) {
      // 调用后端接口获取庭审详细信息
      request.get(`/api/hearing/getHearingById/${row.hearingId}`).then(res => {
        if (res && res.code === 200 && res.data) {
          // 设置当前庭审详情数据
          this.currentHearingDetail = res.data;
          // 显示庭审详情模态框
          this.hearingDetailDialogVisible = true;
        } else {
          this.$message.error('获取庭审详情失败');
        }
      }).catch(error => {
        // 获取庭审详情失败
        this.$message.error('获取庭审详情失败，请重试');
      });
    },
    // 下载材料
    async downloadMaterial(materialId) {
      // 获取下载链接并跳转
      const res = await request.get(`/api/material/download/${materialId}`);
      if (res.data) {
        window.open(res.data);
      }
    },
    

    // 查询代理人列表
    async loadAgentList() {
      if (!this.form.caseId) return
      const res = await getAgentsByCaseId(this.form.caseId)
              // 庭审详情获取成功
      this.agentList = res.data || []
    },
    // 新增代理人
    handleAddAgent() {
      this.agentForm = {
        agentName: '',
        partyId: '',
        mobilePhone: '',
        identityNumber: ''
      }
      this.editingAgentId = null
      this.agentDialogVisible = true
    },
    // 编辑代理人
    handleEditAgent(row) {
      this.agentForm = { ...row, identityNumber: row.identityNumber || '' }
      this.editingAgentId = row.agentId
      this.agentDialogVisible = true
    },
    // 删除代理人
    async handleDeleteAgent(row) {
      this.$confirm('确定要删除该代理人吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      await deleteAgent(row.agentId)
      this.$message.success('删除成功')
      this.loadAgentList()
      }).catch(() => {
        // 用户点击取消，不做任何操作
      })
    },
    // 保存代理人
    async saveAgent() {
      this.$refs.agentFormRef.validate(async (valid) => {
        if (!valid) return;

        // 从localStorage获取tenantId
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const tenantId = userInfo.tenantId;
        
        const agentData = {
          agentName: this.agentForm.agentName,
          partyId: this.agentForm.partyId,
          mobilePhone: this.agentForm.mobilePhone,
          caseId: this.form.caseId,
          identityNumber: this.agentForm.identityNumber,
          tenantId: tenantId
        };
        
        if (this.editingAgentId) {
          await updateAgent(this.editingAgentId, agentData)
          this.$message.success('修改成功')
        } else {
          await createAgent(agentData)
          this.$message.success('新增成功')
        }
        this.agentDialogVisible = false
        this.loadAgentList()
      });
    },
    // 加载书记员和仲裁员下拉数据
    async loadUserList() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const tenantId = userInfo.tenantId;
      if (!tenantId) {
        this.$message.error('请先登录');
        this.$router.push('/login');
        return;
      }
      const res = await request.get('/api/user/listByTenant', { params: { tenantId } });
      this.userOptions = res.data || [];
      this.arbitratorOptions = this.userOptions;
      this.clerkOptions = this.userOptions;
    },
    handleNotifyHearing(row) {
      this.$message.info(`发送庭审通知给：${row.hearingId}`);
      // 这里可以补充实际的通知逻辑
    },
    // 处理预备开庭
    async handlePrepareHearing(row) {
      try {
        this.$confirm('确定要将庭审状态改为预备开庭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 调用预备开庭接口
          const res = await prepareHearing(row.hearingId);
          if (res.code === 200) {
            this.$message.success('预备开庭成功');
            // 刷新庭审列表
            this.fetchHearingList();
          } else {
            this.$message.error(res.message || '预备开庭失败');
          }
        });
      } catch (error) {
        console.error('预备开庭失败:', error);
        this.$message.error('预备开庭失败，请重试');
      }
    },
    // 打开上传弹窗
    openUploadDialog() {
      this.uploadForm.materialName = '';
      this.uploadForm.materialCategory = null;
      this.uploadForm.partyId = null; // 清空当事人ID
      this.selectedFile = null;
      this.uploadDialogVisible = true;
    },
    // 材料分类变化时触发
    onMaterialCategoryChange(value) {
      if (value === 4) { // 证据分类
        this.uploadForm.partyId = null; // 清空当事人ID
      }
    },
    // 文件选择回调
    handleFileChange(file, fileList) {
      // 限制只能选择一个文件
      if (fileList.length > 1) {
        this.$message.warning('只能上传一个文件，请重新选择');
        return;
      }
      this.selectedFile = file.raw; // 保存原始文件对象
      // 如果材料名称为空，自动填入文件名
      if (!this.uploadForm.materialName) {
        this.uploadForm.materialName = file.name;
      }
    },
    // 文件移除回调
    handleFileRemove(file, fileList) {
      this.selectedFile = null;
      this.$message.info('已移除文件');
    },
    // 手动上传文件
    handleManualUpload() {
      // 点击上传按钮
      if (!this.selectedFile) {
        this.$message.warning('请先选择文件');
        return;
      }
      if (!this.uploadForm.materialName || !this.uploadForm.materialCategory) {
        this.$message.warning('请填写材料名称和选择分类');
        return;
      }
      
      // 如果是证据材料，验证当事人选择
      if (this.uploadForm.materialCategory === 4) {
        if (!this.uploadForm.partyId) {
          this.$message.warning('证据材料必须选择提交当事人');
          return;
        }
      }
      
      // 开始上传文件
      
      // 组装上传参数
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      this.uploadData = {
        caseId: this.form.caseId, // 案件ID
        tenantId: userInfo.tenantId, // 租户ID
        uploaderId: userInfo.userId, // 上传人ID
        materialCategory: this.uploadForm.materialCategory, // 材料分类
        materialName: this.uploadForm.materialName, // 材料名称
        partyId: this.uploadForm.partyId // 提交当事人ID
      };
      
      // 上传参数已准备
      
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('caseId', this.uploadData.caseId);
      formData.append('tenantId', this.uploadData.tenantId);
      formData.append('uploaderId', this.uploadData.uploaderId);
      formData.append('materialCategory', this.uploadData.materialCategory);
      formData.append('materialName', this.uploadData.materialName);
      if (this.uploadData.partyId) {
        formData.append('partyId', this.uploadData.partyId);
      }
      
      // 使用request工具发送请求
      request.post(this.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // 上传响应已接收
        if (response.code === 200) {
          this.$message.success('上传成功');
          this.uploadDialogVisible = false; // 关闭弹窗
          this.fetchPageData(); // 刷新材料列表
        } else {
          this.$message.error(response.message || '上传失败');
        }
      }).catch(error => {
        // 上传失败
        this.$message.error('上传失败: ' + (error.message || '未知错误'));
      });
    },
    // 上传成功回调（保留，以防其他地方调用）
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.$message.success('上传成功');
        this.uploadDialogVisible = false; // 关闭弹窗
        this.fetchPageData(); // 刷新材料列表
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    // 上传失败回调（保留，以防其他地方调用）
    handleUploadError() {
      this.$message.error('上传失败');
    },
    // 材料分类格式化显示
    formatMaterialCategory(row) {
      const map = {
        1: '仲裁申请书',
        2: '庭审笔录',
        3: '案件信息（Excel）',
        4: '证据',
        5: '其他'
      };
      return map[row.materialCategory] || '未知';
    },
    // 提交当事人格式化显示
    formatSubmitter(row) {
      if (row.materialCategory === 4 && row.partyId) {
        const party = this.partyList.find(p => p.partyId === row.partyId);
        if (party) {
          return `${party.partyName} (${party.partyIdentity === 1 ? '申请人' : '被申请人'})`;
        }
      }
      return '';
    },
    // 计算开庭公告送达状态
    calculateSmsDeliveryStatus(hearingId) {
      // 获取该庭审的所有参会人
      const participants = this.getHearingParticipants(hearingId);
      
      if (!participants || participants.length === 0) {
        return '暂无参会人';
      }
      
      // 检查是否所有参会人都已送达
      const allDelivered = participants.every(participant => participant.isSmsSent === 1);
      
      if (allDelivered) {
        return '全部送达';
      } else {
        return '请完成短信通知';
      }
    },
    
    // 获取庭审的参会人列表
    getHearingParticipants(hearingId) {
      // 这里需要根据hearingId获取参会人列表
      // 可以从当事人列表和代理人列表中筛选
      const allParticipants = [];
      
      // 添加当事人（所有案件的当事人都可能参与庭审）
      this.partyList.forEach(party => {
        allParticipants.push({
          id: party.partyId,
          name: party.partyName,
          type: 'party',
          isSmsSent: party.isSmsSent || 0
        });
      });
      
      // 添加代理人（所有案件的代理人都可能参与庭审）
      this.agentList.forEach(agent => {
        allParticipants.push({
          id: agent.agentId,
          name: agent.agentName,
          type: 'agent',
          isSmsSent: agent.isSmsSent || 0
        });
      });
      
      return allParticipants;
    },
  }
};
</script>

<style scoped>
/* 案件编辑页面整体容器样式 */
.case-edit-container { padding: 20px; background-color: #f0f2f5; }
/* 卡片美化：圆角+阴影 */
.box-card { margin-bottom: 20px; border-radius: 10px; box-shadow: 0 2px 8px #f0f1f2; }
/* 表格居中显示 */
.el-table th, .el-table td { text-align: center; }
/* 表头美化 */
.el-table .el-table__header th { background: #f7fafd; color: #333; font-weight: bold; }
/* 表体背景色 */
.el-table .el-table__body td { background: #fff; }
/* 悬浮高亮行 */
.el-table .el-table__row:hover td { background: #f0f7ff; }
.top-bar { background-color: #409eff; padding: 10px 20px; color: white; border-radius: 4px; margin-bottom: 20px; }
.top-bar-title { font-size: 18px; font-weight: bold; }
.clearfix:before, .clearfix:after { display: table; content: ""; }
.clearfix:after { clear: both }
/* 保存按钮右下角浮动样式 */
.save-btn-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.action-btn {
  margin-right: 12px; /* 按钮右侧间距 */
  color: #409EFF;     /* Element主色，与材料操作栏一致 */
}
.action-btn:last-child {
  margin-right: 0;
}
.document-dialog .el-message-box__content {
  max-height: 60vh;
  overflow-y: auto;
  font-size: 15px;
  line-height: 1.8;
}
.video-dialog .el-message-box__content {
  padding: 0;
}
.video-dialog video {
  display: block;
  margin: 0 auto;
  background: #000;
}

/* 材料预览弹窗样式 */
.material-preview-dialog >>> .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.material-preview-dialog >>> .el-dialog__body {
  padding: 0;
  background: #fff;
  height: 85vh;
}

.material-preview-dialog >>> .onlyoffice-wrapper {
  border-radius: 0;
}

.material-preview-dialog >>> .onlyoffice-content {
  border-radius: 0;
}

/* 商务风格上传弹窗美化 */
.upload-material-dialog {
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 4px 24px rgba(0,0,0,0.10); /* 柔和阴影 */
  padding-bottom: 10px;
  background: #fff;
}
.upload-form {
  margin-top: 10px;
  padding: 0 8px;
}
.upload-form .el-form-item {
  margin-bottom: 18px;
}
.upload-form .el-input,
.upload-form .el-select {
  width: 100%;
}
.upload-btn-block {
  display: block;
}
.upload-btn-block .el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
  line-height: 1.4;
}
.upload-btn-block .el-upload__tip i {
  margin-right: 4px;
  color: #409EFF;
}
.dialog-footer {
  text-align: right;
  padding-right: 10px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
}
.upload-material-dialog .el-dialog__header {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
  font-weight: 600;
  font-size: 17px;
  color: #222;
}
.upload-material-dialog .el-dialog__body {
  padding: 20px;
}
.upload-material-dialog .upload-form .el-form-item {
  margin-bottom: 20px;
}
.upload-material-dialog .upload-form .el-input__inner,
.upload-material-dialog .upload-form .el-select .el-input__inner {
  text-align: left;
}
.upload-material-dialog .upload-form .el-select .el-input__inner {
  text-align: left;
}
.upload-material-dialog .el-dialog__footer {
  background: #fafbfc;
  border-radius: 0 0 10px 10px;
}

/* 视频弹窗样式 */
.video-dialog .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.video-dialog .el-dialog__body {
  padding: 0;
  background: #000;
  text-align: center;
}

.video-dialog video {
  display: block;
  margin: 0 auto;
  background: #000;
  border-radius: 0;
}

.video-dialog .el-dialog__header {
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  padding: 15px 20px;
}

.video-dialog .el-dialog__title {
  font-weight: 600;
  color: #303133;
}

/* 图片预览弹窗样式 */
.image-preview-dialog .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.image-preview-dialog .el-dialog__body {
  padding: 0;
  background: #f5f7fa;
  text-align: center;
  max-height: 70vh;
  overflow: hidden;
}

.image-preview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: #f5f7fa;
  padding: 20px;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.image-preview-dialog .el-dialog__header {
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  padding: 15px 20px;
}

.image-preview-dialog .el-dialog__title {
  font-weight: 600;
  color: #303133;
}

.image-preview-dialog .el-dialog__footer {
  background: #fafbfc;
  border-top: 1px solid #e4e7ed;
  padding: 15px 20px;
  text-align: center;
}

.image-preview-dialog .dialog-footer .el-button {
  margin: 0 8px;
}

.submitter-selection {
  display: flex;
  align-items: center;
  gap: 10px;
}

.submitter-selection .el-select {
  flex-shrink: 0;
}

</style>